import { observer } from "mobx-react-lite";
import MultiSwitcherStage from "../components/ui/MultiSwitcherStage";
import MultiRangeSlider from "../components/ui/MultiRangeSlider";
import Dropbox from "../components/ui/Dropbox";
import TableBlock from "../components/custom_tables/tableBlock";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import SingleTable from "../components/tables/SingleTable";
import { ReactComponent as Plus } from "../images/icons/plus.svg";
import { ReactComponent as Find } from "../images/icons/find.svg";
import { ReactComponent as Filter } from "../images/icons/filter.svg";
import PaydayAPI from "../API/PaydayAPI";
import TablePaydayRow from "../components/custom_tables/tablePaydayRow";

import { Context } from "..";
import SingleRowColored from "../components/tables/SingleRowColored";
import Clicker from "../components/ui/Clicker";
import useNotification from "../hooks/useNotification";
import usePayday from "../hooks/usePayday";
import useAssociationsEditor from "../hooks/useAssociationsEditor";
import AuthAPI from "../API/AuthAPI";

const Payday = () => {
    
    const { success, warning, error } = useNotification();
    const { store } = useContext(Context);

    const [isTaskView, setTaskView] = useState(false);
    const [objects, setObjects] = useState([]);
    const [newCell, setNewCell] = useState(null);

    const [rangeParams, setRangePrams] = useState({ min: 1, max: 32 });
    const [ranges, setRanges] = useState([]);
    
    const [isOpenedDropbox, setIsOpenedDropbox] = useState(null);
    const [currentCount, setCurrentCount] = useState(0);
    const [dropboxes, setDropboxes] = useState({});
    const changeOpenedDropbox = (dropboxName, state) => {
        let newDropboxes = { ...dropboxes };
        if (isOpenedDropbox != null) newDropboxes[isOpenedDropbox].isOpened = false;
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], isOpened: state } }
        setDropboxes(newValue);
        // updateCalcValues(newValue);

        if (state) setIsOpenedDropbox(dropboxName);
        else setIsOpenedDropbox(null);
    }
    const changeValueDropbox = (dropboxName, value) => {
        let newDropboxes = { ...dropboxes, [isOpenedDropbox]: { ...dropboxes[isOpenedDropbox], isOpened: false } };
        let newValue = { ...newDropboxes, [dropboxName]: { ...newDropboxes[dropboxName], currentValue: value } };
        setDropboxes(newValue);

        if (dropboxName != "association") return;
        changeAssociation(value != 0 ? newDropboxes.association.values[value].id : null);
    }

    const { payday_summ, payday_hourCost, payday_changeAssociation } = usePayday(currentCount);
    const { associationsDropbox, changeAssociation } = useAssociationsEditor("payday_id");
    useEffect(() => {
        if (!associationsDropbox || associationsDropbox === null || !associationsDropbox.values || associationsDropbox.values.length === 0) return;
        payday_changeAssociation();
        setDropboxes({ ...dropboxes, association: associationsDropbox });
    }, [associationsDropbox]);
    useEffect(() => {
        if (store.userInfo.countWorkers === undefined) return;
        setRangePrams({ ...rangeParams, max: store.userInfo.countWorkers });
    }, [store.userInfo.countWorkers]);

    useLayoutEffect(() => {
        // if (!isTaskView && scrollElement.current.scrollHeight > scrollElement.current.clientHeight) setHasScroll(true);
        loadData().then(() => console.log("Список задач загружен"));
        loadRanges().then(() => console.log("Список промежутков загружен"));
    }, [isTaskView]);

    const loadData = async () => {
        try {
            const response = await PaydayAPI.getAll();
            if (response.status !== 200) throw response;
            setObjects(response.data);
            return response.data;
        } catch (err) {
            console.log("[x] Ошибка получения задач в разделе ЗП:", err);
        }
    }
    const loadRanges = async () => {
        try {
            const response = await PaydayAPI.getAllRanges();
            if (response.status !== 200) throw response;
            for (let i = 0; i < response.data.length; i++) {
                response.data[i].hideStart = (response.data[i].start == response.data[i].end);
            }
            setRanges(response.data);
            return response.data;
        } catch (err) {
            console.log("[x] Ошибка получения промежутков в разделе ЗП:", err);
        }
    }

    // Редактирование задачи в ЗП
    const setValue = async (index, newValue, field) => {
        let newArr = objects;
        newArr[index][field] = newValue;
        setObjects([...newArr]);
    }
    const removeValue = async (index) => {
        try {
            let newObjects = objects;
            if (!newObjects[index].id) newObjects = await loadData();
            const response = await PaydayAPI.remove(newObjects[index].id);
            if (response.status !== 200) throw response;

            newObjects = newObjects.filter((item, itemIndex) => itemIndex !== index);
            setObjects([...newObjects]);
        } catch (err) {
            console.log("[x] Ошибка удаления задачи ЗП:", err);
            error("Ошибка удаления задачи ЗП");
        }
    }
    const saveValue = async (value) => {
        try {
            const response = await PaydayAPI.update(value);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log("[x] Ошибка обновления строки в ЗП:", err);
            error("Ошибка сохранения задачи ЗП");
        }
    }
    // Создание новой задачи в ЗП
    const addingValue = () => {
        setNewCell({ 
            name: "", 
            interval: 1, 
            time: 0, 
            isRequired: false, 
            isStatic: false,
        });
    }
    const setValueNewCell = async (value, field) => {
        let newValue = newCell;
        newValue[field] = value;
        setNewCell({ ...newValue });
    }
    const saveNewCell = async (value) => {
        try {
            const response = await PaydayAPI.create(value);
            if (response.status !== 200) throw response;
                        
            let newObjects = await loadData();
            setObjects(newObjects);
            setNewCell(null);
        } catch (err) {
            console.log("[x] Ошибка создания строки в ЗП:", err);
        }
    }

    // Создание и редактирование промежутков в ЗП
    const addRange = async () => {
        try {
            if (ranges.length == 0) {
                let newRange = { start: 1, end: rangeParams.max, percent: 0, hideStart: false };
                const response = await PaydayAPI.createRange(newRange);
                if (response.status !== 200) throw response; 

                let newRanges = await loadRanges();
                setRanges(newRanges);
                return;
            }

            let lastEnd = ranges[ranges.length - 1].end;
            let newRange = { start: lastEnd + 1, end: lastEnd + 1, percent: 0, hideStart: true };
            if (lastEnd < rangeParams.max - 1) {
                const response = await PaydayAPI.createRange(newRange);
                if (response.status !== 200) throw response;

                let newRanges = await loadRanges();
                setRanges(newRanges);
            } else {
                warning("Отсутствует диапазон для создания промежутка в ЗП");
            }
        } catch (err) {
            console.log(`[x] Ошибка создания прмоежутка в ЗП:`, err);
            error("Ошибка создания промежутка в ЗП");
        }
    };
    const editRange = async (range) => {
        try {
            const response = await PaydayAPI.editRange(range);
            if (response.status !== 200) throw response;
        } catch (err) {
            console.log(`[x] Ошибка обновления промежутка в ЗП:`, err);
            error("Ошибка обновления промежутка в ЗП");
        }
    };
    const removeRange = async (index) => {
        try {
            let newRanges = ranges;
            if (!newRanges[index].id) newRanges = await loadRanges();
            const response = await PaydayAPI.removeRange(newRanges[index].id);
            if (response.status !== 200) throw response;

            newRanges = newRanges.filter((item, itemIndex) => itemIndex !== index);
            setRanges([...newRanges]);
        } catch (err) {
            console.log("[x] Ошибка удаления промежутка в ЗП:", err);
            error("Ошибка удаления промежука в ЗП");
        }
    }


    const updateCountWorkers = async (value) => {
        try {
            const response = await AuthAPI.editPaydayCountWorkers(value);
            if (response.status !== 200) throw response;

            let newRanges = await loadRanges();
            setRanges(newRanges);
            success("Максимальное количество сотрудников обновлено");
        } catch (err) {
            console.log("[x] Не удалось сохранить новое значение количества сотрудников в ЗП:", err);
            error("Ошибка сохранения максимального количества сотрудников");
        }
    }

    
    const hasInRange = (num) => {
        let rangeIndex = 0;
        while (rangeIndex < ranges.length) {
            let range = ranges[rangeIndex];
            if (num >= range.start && num <= range.end) return range;
            rangeIndex++;
        }
        return false;
    }
    const formatNumber = (num) => {
        if (!num) return 0;
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    const getSummsWithoutWorkers = () => {
        try {
            let summ = 0;
            for (let i = 0; i < objects.length; i++) {
                if (objects[i].isRequired == true) summ += Math.ceil(objects[i].time / (12 / objects[i].interval)); 
            }
            return Math.ceil(summ * (payday_hourCost / 60));
        } catch (err) {
            console.log(`[payday] [getSuum_withoutWorkers] error: ${err}`);
            return 0;
        }
    }
    const getSummByCount = (count) => {
        let summForWorkers = 0;
        let summNotWorkers = 0;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].isStatic == false) summForWorkers += Math.ceil(objects[i].time / (12 / objects[i].interval));
            else summNotWorkers += objects[i].time;
        }
        return Math.ceil((summForWorkers * count + summNotWorkers) * (payday_hourCost / 60));
    }

    return (
        <div className="setupBlock">
            <div className="managementMenu">
                <button className="activeButton" onClick={() => window.location.replace("/calc")}>Назад</button>
                <MultiSwitcherStage 
                    values={[{ name: "Диапазон кол-ва сотрудников" }, { name: "Задачи" }]}
                    selectValue={(index) => setTaskView(index == 1)}
                />
            </div>
            { !isTaskView
                ? <div className="setupContent">
                    <div className="paramsBlock">
                        <div className="title">Зарплата</div>
                        { dropboxes.association && <div className={`paramsList${dropboxes.association.currentValue === 0 ? " error" : ""}`} style={{ flex: 0 }}>
                            <ul>
                                <li>
                                    <div className="params" style={{ width: 430 }}>
                                        <div className="title">Ответственный</div>
                                        <div className="attribute">
                                            <Dropbox 
                                                textValue={dropboxes.association.values[dropboxes.association.currentValue]?.name}
                                                isRight={true}
                                                isOpen={dropboxes.association.isOpened}
                                                changeOpened={(value) => changeOpenedDropbox("association", value)}
                                                isError={dropboxes.association.currentValue === 0}
                                            >
                                                {dropboxes.association.values.map((item, index) => <li 
                                                    className={dropboxes.association.currentValue === index || (dropboxes.association.currentValue === null && index == 0) ? "selected" : ""}
                                                    key={item+index}
                                                    onClick={() => changeValueDropbox("association", index)}
                                                >
                                                    <div className="number">{index+1}.</div>
                                                    <div className="value">{item.name}</div>
                                                </li>)}
                                            </Dropbox>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div> }
                        <div className="paramsList">
                            <ul>
                                <li>
                                    <div className="params" style={{ width: 430 }}>
                                        <div className="title">Количетсво сотрудников</div>
                                        <div className="attribute">
                                            <Clicker
                                                isDecimal={true}
                                                max={rangeParams.max}
                                                min={0}
                                                step={1}
                                                value={currentCount}
                                                setValue={(newValue) => setCurrentCount(newValue)}
                                            />
                                        </div>
                                    </div>
                                    <div className="summ">{
                                        currentCount == 0 
                                            ? formatNumber(getSummsWithoutWorkers())
                                            : formatNumber(Math.ceil(getSummByCount(currentCount) - (getSummByCount(currentCount) / 100 * (hasInRange(currentCount) ? hasInRange(currentCount).percent : 0))))
                                        } ₽</div>
                                </li>
                            </ul>
                            <div className="summ">
                                <div className="text">Итого:</div>
                                <div className="value">{
                                    currentCount == 0 
                                        ? formatNumber(getSummsWithoutWorkers())
                                        : formatNumber(Math.ceil(getSummByCount(currentCount) - (getSummByCount(currentCount) / 100 * (hasInRange(currentCount) ? hasInRange(currentCount).percent : 0))))
                                    } ₽</div>
                            </div>
                        </div>
                    </div>
                    <div className="contentSetupBlock">
                        <div>
                            <div className="title">
                                <div className="text">Диапазон количества сотрудников</div>
                                { store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={addRange}>Добавить <Plus/></button> }
                            </div>
                            <div className="content_line">
                                <div className="title">Макс. кол-во сотрудников:</div>
                                <div className="value"><TableBlock
                                    value={rangeParams.max}
                                    setValue={(newValue) => {setRangePrams({...rangeParams, max: newValue})}}
                                    units="чел."
                                    isSaved={true}
                                    save={() => updateCountWorkers(rangeParams.max)}
                                    saveValue={(newValue) => updateCountWorkers(newValue)}
                                    disabled={!store.userInfo || store.userInfo.isLicensed == false}
                                /></div>
                            </div>
                            {/* {groupsDifficulty.length > 0 && <MultiSwitcherStage 
                                values={groupsDifficulty}
                                selectValue={(index) => setActiveGroup(index)}
                                backIsWhite={true}
                            />} */}
                            <MultiRangeSlider 
                                ranges={ranges}
                                setRangesArr={(value, index) => {
                                    if (ranges[index].start != value[index].start || 
                                        ranges[index].end != value[index].end || 
                                        ranges[index].percent != value[index].percent) 
                                    {
                                        setRanges(value)
                                    }
                                }}
                                saveRanges={(newRange) => {
                                    editRange(newRange)
                                }}
                                min={rangeParams.min} 
                                max={rangeParams.max}
                                onDelete={(index) => removeRange(index)}
                                disabled={!store.userInfo || store.userInfo.isLicensed == false}
                            />
                        </div>
                        <div>
                            <div className="title">Стоимость по количеству сотрудников</div>
                            <SingleTable header={{ title: "Кол-во сотрудников", list: [{ name: "Изначальная стоимость" }, { name: "Скидка" }, { name: "Стоимость со скидкой" }] }}>
                                <SingleRowColored values={[
                                    {
                                        value: 0,
                                        isTitle: true,
                                    },
                                    { 
                                        value: getSummsWithoutWorkers(),
                                        prefix: " ₽",
                                    },
                                    { 
                                        value: 0, 
                                        prefix: "%",
                                    },
                                    {
                                        value: getSummsWithoutWorkers(),
                                        prefix: " ₽"
                                    }
                                ]}/>
                                {Array.from({ length: Number(rangeParams.max) }, (item, index) => 
                                    <SingleRowColored values={[
                                        {
                                            value: index+1,
                                            isTitle: true
                                        },
                                        { 
                                            value: formatNumber(getSummByCount(index+1)),
                                            prefix: " ₽",
                                        },
                                        { 
                                            value: hasInRange(index+1) ? hasInRange(index+1).percent : 0, 
                                            prefix: "%",
                                        },
                                        {
                                            value: formatNumber(Math.ceil(getSummByCount(index+1) - (getSummByCount(index+1) / 100 * (hasInRange(index+1) ? hasInRange(index+1).percent : 0)))),
                                            prefix: " ₽"
                                        }
                                    ]} key={index+"num"}/>
                                )}
                            </SingleTable>
                        </div>
                    </div>
                </div> 
                : <div className="setupBigContent">
                    <div className="title">Задачи</div>
                    <div className="tableContainer">
                        <div className="tableSettings">
                            <div className="left_side">
                                <div className="text" style={{ marginLeft: "10px" }}>Всего найдено записей: {objects.length}</div>
                            </div>
                            <div className="right_side">
                                <button className="defaultButton disabled"><Filter/></button>
                                <button className="defaultButton disabled"><Find/></button>
                                { store.userInfo && store.userInfo.isLicensed == true && <button className="activeButton" onClick={addingValue}>Добавить <Plus/></button> }
                            </div>
                        </div>
                        <div className="tableContent">
                            {/* <div className={scrollElement ? "tableScroller scrolled" : "tableScroller"} ref={scrollElement}> */}
                            <div className="tableScroller" style={{ gap: "20px" }}>
                                <div className="tableHeader">
                                    <div className="num">№п/п</div>
                                    <div className="name">Регулярные операции</div>
                                    <div className="attrs">
                                        <div className="tdContainer">
                                            <div className="title">Переодичность</div>
                                            <div className="subTitle">(раз в год)</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">Время</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">Сотрудники</div>
                                        </div>
                                        <div className="tdContainer">
                                            <div className="title">Учитывать <br />кол-во сотруд.</div>
                                        </div>
                                    </div>
                                </div>
                                <ul className="TABLE">
                                    {objects && objects.length > 0 && objects.map((item, index) => <TablePaydayRow 
                                        value={item} 
                                        setValue={(newValue, field) => setValue(index, newValue, field)}
                                        saveValue={(value) => saveValue(value)}
                                        onDelete={() => removeValue(index)}
                                        index={objects.length - index - 1}
                                        key={item+index}
                                    />)}
                                    {newCell && <TablePaydayRow 
                                        value={newCell} 
                                        setValue={(newValue, field) => setValueNewCell(newValue, field)}
                                        saveValue={(value) => saveNewCell(value)}
                                        onDelete={() => setNewCell(null)}
                                        index={-1}
                                        isNew={true}
                                    /> }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default observer(Payday);
